import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=815765b6&scoped=true"
var script = {}
import style0 from "./Pricing.vue?vue&type=style&index=0&id=815765b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815765b6",
  null
  
)

export default component.exports